import { Form, Input } from "decorator-form";
import moment from "moment";
import React from "react";
import { Field } from "typegraph";

import InputType from "common/form/InputType";
import { ButtonView } from "common/views/button/Button.view";
import HeadingView from "common/views/heading/Heading.view";
import Query from "core/api/QueryComponent";
import Label from "core/components/label/Label";
import { IPanelProps, Panel } from "core/decorators/Panel";
import StringUtil from "core/util/StringUtil";

@Form({title: "Intel Rewards Panel"})
class IntelRewardsPanelConfig {

	@Input({type: InputType.TEXT, title: "Link"})
	public link: string;

}

class PropertyResolverResult {

	@Field()
	public uuid: string;

	@Field()
	public value: string;

}

class RewardsQuery {

	@Field({
		aliasFor: "propertyResolver",
		params: {params: {
			uuid: "intelrco:rewards",
			input: JSON.stringify({
				key: 'balance'
			})
		}},
		entity: PropertyResolverResult
	})
	public balance: PropertyResolverResult;

	@Field({
		aliasFor: "propertyResolver",
		params: {params: {
			uuid: "intelrco:rewards",
			input: JSON.stringify({
				key: 'received',
				startDate: moment().startOf('year').format('YYYY-MM-DD[T]HH:mm:ss[Z]')
			})
		}},
		entity: PropertyResolverResult
	})
	public received: PropertyResolverResult;

}

@Panel({id: 'intelrco-rewards', configClass: IntelRewardsPanelConfig})
class IntelRewardsPanel extends React.Component<IPanelProps<IntelRewardsPanelConfig>> {

	public render() {

		return (
			<Query.Root entity={RewardsQuery}>
				{
					(req) => {

						const balance = StringUtil.toInteger(req.data && req.data.balance && req.data.balance.value, 0);
						const received = StringUtil.toInteger(req.data && req.data.received && req.data.received.value, 0);

						return (
							<React.Fragment>
								{
									received > 0 && (
										<HeadingView viewKey="counts">
											<Label
												k="intelrco.rewards"
												v="Congrats! You've earned ${received} chips towards the reward shop."
												allowHtml={true}
												allowMarkdown={true}
												args={{received}}
											/>
										</HeadingView>
									)
								}
								{
									balance > 0 && (
										<ButtonView viewKey="redeem.button" href={this.props.config.link}>
											<Label
												k="intelrco.rewards.redeem"
												v="Redeem Chips (${balance} available)"
												args={{balance}}
											/>
										</ButtonView>
									)
								}
							</React.Fragment>
						);
					}
				}
			</Query.Root>
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/client/intelrco/IntelRewards.panel.tsx